import { render, staticRenderFns } from "./BookingPositionModalUpdate.vue?vue&type=template&id=324823a4&"
import script from "./BookingPositionModalUpdate.vue?vue&type=script&lang=js&"
export * from "./BookingPositionModalUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports